// extracted by mini-css-extract-plugin
export default {"gap_20":"EditCategory_gap_20__77dxA"};